export const WALLET_TYPE = 'wallet_type'
export const WALLET = 'address'
export const CHANGE_WALLET = 'change_wallet'